import React from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { DocumentsList } from '../components/features/DocumentsList';

export const DocumentsPage: React.FC = () => {
  return (
    <AppLayout title="Мои документы">
      <DocumentsList />
    </AppLayout>
  );
};
